import { render, staticRenderFns } from "./SafetyRadiationModal.vue?vue&type=template&id=049c0e8b&scoped=true&"
import script from "./SafetyRadiationModal.vue?vue&type=script&lang=js&"
export * from "./SafetyRadiationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c0e8b",
  null
  
)

export default component.exports